import "./playAnimation.scss"
import { useEffect, useRef, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { TADUM_SOUND_URL, BASE_IMG_URL } from "../../requests";

const PlayAnimation = () => {

	let history = useHistory();
	let location = useLocation();
	const soundRef = useRef(null);
	const [showVideo, setShowVideo] = useState(false);
	const videoPath = location.state?.videoPath;

	const handleTadum = () => {
		if (soundRef.current) {
			soundRef.current.currentTime = 0;
			const playPromise = soundRef.current.play();
			if (playPromise !== undefined) {
				playPromise.catch(error => {
					console.warn("Audio play prevented:", error);
				});
			}
		}
	}

	useEffect(() => {
		if (!showVideo) {
			handleTadum();
			const timer = setTimeout(() => {
				if (videoPath) {
					setShowVideo(true);
				} else {
					history.push('/browse');
				}
			}, 4200);
			return () => clearTimeout(timer);
		}
	}, [history, videoPath, showVideo])

	return (
		<div className='PlayAnimation__wrp' style={{ background: '#000', width: '100vw', height: '100vh', position: 'fixed', top: 0, left: 0, zIndex: 9999 }}>
			{!showVideo && (
				<>
					<audio ref={soundRef} src={TADUM_SOUND_URL} />
					<span className="PlayAnimation__text">
						PSFLIX
					</span>
				</>
			)}
			{showVideo && (
				<video
					src={encodeURI(`${BASE_IMG_URL}/${videoPath.replace(/^\//, '')}`)}
					autoPlay
					controls
					style={{ width: '100%', height: '100%', objectFit: 'contain' }}
				/>
			)}
			<button 
				onClick={() => history.goBack()} 
				style={{ position: 'absolute', top: 20, left: 20, zIndex: 10000, background: 'transparent', border: 'none', color: '#fff', fontSize: '24px', cursor: 'pointer' }}
			>
				&#8592; Back
			</button>
		</div>
	)
}

export default PlayAnimation
